import { Corridor } from '@app/pcs/models';
import * as R from 'ramda';

export const getCorridorImage = (corridor: Corridor): string =>
  getCorridorImageById(R.prop('id', corridor));

export const getCorridorImageById = (id: number): string =>
  `assets/images/corridors/${id}.svg`;
